import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Entry } from 'contentful';
import { Row } from '@sumup-oss/circuit-ui/legacy';

import { getPosArticlesPageStaticProps } from './articlesStatic';

import SectionsList from 'components/SectionsList';
import MobileSectionsList from 'components/MobileSectionsList';
import {
  ContentfulArticle,
  ContentfulCountry,
  SectionTree,
  SectionTypeTree,
} from 'types/common';
import {
  PageNavigation,
  PageContent,
  PreviewEditButton,
} from 'components/styledComponents';
import { makeContentfulEntryUrl } from 'services/contentful';
import Article from 'pages/articles/components/Article';

type ArticlePageProps = {
  articleData: ContentfulArticle;
  articleId: string;
  chatAvailable: boolean;
  countriesData: Entry<ContentfulCountry>[];
  preview: boolean | null;
  sectionTree: SectionTree;
  sectionTypeTree: SectionTypeTree;
};

const Page: NextPage<ArticlePageProps> = ({
  articleData,
  chatAvailable,
  countriesData,
  preview,
  sectionTree,
  sectionTypeTree,
}) => {
  const router = useRouter();
  if (router.isFallback) {
    return <div>Page is loading. This is the loader to show meanwhile</div>;
  }

  return (
    <Row>
      <PageNavigation span="0" skip="0">
        <MobileSectionsList
          sectionTypeTree={sectionTypeTree}
          sectionTree={sectionTree}
          isPos
        />
        <SectionsList
          sectionTypeTree={sectionTypeTree}
          sectionTree={sectionTree}
          isPos
        />
      </PageNavigation>
      <PageContent span="0" skip="0">
        {preview && (
          <PreviewEditButton
            href={makeContentfulEntryUrl(articleData.sys.id)}
            target="blank"
          >
            Edit
          </PreviewEditButton>
        )}
        {articleData && (
          <Article
            articleData={articleData}
            chatAvailable={chatAvailable}
            countriesData={countriesData}
            isPos
          />
        )}
      </PageContent>
    </Row>
  );
};

export const getStaticProps = getPosArticlesPageStaticProps;

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticPaths = async () => ({
  paths: [],
  fallback: true,
});

export default Page;
